const formatterSC = Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

const formatterCC = Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
});

export default function animateValue(
  el: HTMLElement,
  start: number,
  end: number,
  duration: number,
  coinType: 'SC' | 'GC' = 'SC',
): void {
  let startTimestamp: number | null = null;
  const step = (timestamp: number) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    el.innerHTML = (coinType === 'GC' ? formatterCC : formatterSC).format(progress * (end - start) + start);
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
}
